export default __webpack_public_path__ + "static/media/bulmafront.e958bff5.svg";